module.exports = __webpack_public_path__ + "img/harmony-tension-table.08204616.jpg";